import { Component, input } from '@angular/core';
import type { OnyxTime, OnyxTimeRange } from '@onyx/angular';
import { OnyxTimePipe } from '@onyx/angular';

@Component({
  selector: 'app-time-cell',
  imports: [OnyxTimePipe],
  templateUrl: './time-cell.component.html',
  styleUrl: './time-cell.component.scss',
})
export class TimeCellComponent {
  public readonly time = input.required<OnyxTime | OnyxTimeRange | null>();
}
